import { useTranslation, Trans } from 'react-i18next'
import { showTrustScoreInfoModal } from './base'
import InfoIcon from './info-icon'
import credit from './images/credit.png'

const CreditUtilization = props => {
  const { t } = useTranslation()

  return (
    <InfoIcon
      {...props}
      onClick={() =>
        showTrustScoreInfoModal({
          title: t('b.liv_score.view.credit_utilization.title', 'Credit Utilization'),
          description: (
            <Trans i18nKey="b.liv_score.view.credit_utilization.text">
              <span>
                <strong>Credit Utilization</strong> is shown on a scale from Poor to Excellent, and
                is calculated by dividing the amount of credit a renter is currently using by the
                total amount available.
              </span>
              <span>
                This can reflect everything from auto & student loans and mortgages, to home equity
                loans and other debts, though some lenders look exclusively at credit cards. The
                lower a renter's Credit Utilization ratio, the better — under 25 percent is
                generally considered the ideal range.
              </span>
            </Trans>
          ),
          image: credit,
          imageHeight: '128px'
        })
      }
    />
  )
}

export default CreditUtilization
